
import $ from 'zzc-zepto';
import confirm from '../components/Confirm';
import { hide } from '../components/Loading';
import * as navigator from '../native/navigator';
import {loginUrl} from '../config';

// $.ajaxSettings.beforeSend = function (xhr) {
//   // see https://github.com/madrobby/zepto/issues/274
//   xhr.withCredentials = true; // TODO(elsigh): Do this in zepto w/ xhrFields.
// };

class HTTPError extends Error {
  constructor(message, status, code) {
    super(message);

    this.status = status;
    this.code = code;
    this.name = 'HTTPError';
  }
}


function ajax(options) {
  return new Promise(function (resolve, reject, onCancel) {
    let xhr = $.ajax(options);

    xhr
      .then(function (body, status, xhr) {
        if (body.code === 0) {
          return resolve(body.data);
        }

        if (body.code === 20300 || body.code === 20011) {
          hide();
          confirm({
            content: '您还没登录当前行程的帐号，请先登录后方可查看行程',
            confirmText: '去登录',
            cancelText: false,
            confirmCallback: function () {
              navigator.push(loginUrl, {
                nc_login: 1,
                ref: window.location.href
              });
            }
          });
          return false;
        }

        let err = new HTTPError(body.msg, xhr.status, body.code);
        reject(err);
      })
      .fail(function (xhr) {
        let err = new HTTPError(xhr.statusText, xhr.status);
        reject(err);
      });

    onCancel(function () {
      xhr.abort();
    });
  });
}

export function get(url, ajaxOptions = {}) {
  ajaxOptions = addApiVersion(ajaxOptions);

  let options = {
    ...ajaxOptions,
    type: 'GET',
    url: url,
    xhrFields: {
      withCredentials: true
    }
  };

  return ajax(options);
}


export function post(url, ajaxOptions = {}) {
  ajaxOptions = addApiVersion(ajaxOptions);
  let options = {
    ...ajaxOptions,
    type: 'POST',
    url: url,
    xhrFields: {
      withCredentials: true
    }
  };

  return ajax(options);
}



/**
 * 所有接口增加上当前版本号api_version
 * @param {} ajaxOptions
 */
function addApiVersion(ajaxOptions){
  ajaxOptions.data = {...ajaxOptions.data};
  ajaxOptions.data.api_version = 'v1.3';

  return ajaxOptions;
}



// WEBPACK FOOTER //
// ./src/utils/http.js